"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./USTrendUtils";

export default function USThreeColSection({ title, items, width = "us-ods-50" }) {
  return (
    <div className={`us-ods-detail-item us-odt-card ${width}`}>
      <div className="us-odstb-title us-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="us-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="us-title-odds">{item.label}</div>
            <div
              className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(
                item.trend,
              )}`}
            >
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
